module.exports = __webpack_public_path__ + "static/media/k5-texture.428ab329.jpg";